export default __webpack_public_path__ + "static/media/GreatParade.17405bd0.svg";